/**
 * Utilitários para campos DATE (sem horário) vindos do backend.
 * Evita deslocamento de um dia ao usar new Date('YYYY-MM-DD'), que o JS trata como UTC.
 */

/**
 * Converte valor de data (DATE ou ISO) em Date local à meia-noite do dia civil.
 * @param {string|Date|null|undefined} value
 * @returns {Date|null}
 */
export function parseDateOnly(value) {
  if (value == null || value === '') return null

  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const str = String(value).trim()
  const datePart = str.split('T')[0]
  const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  return new Date(year, month - 1, day)
}

/**
 * Formata campo DATE para exibição (pt-BR).
 * @param {string|Date|null|undefined} value
 * @param {string} [locale='pt-BR']
 * @returns {string}
 */
export function formatDateOnly(value, locale = 'pt-BR') {
  const date = parseDateOnly(value)
  if (!date) return '-'
  return date.toLocaleDateString(locale)
}

/**
 * Converte campo DATE para valor de input type="date" (YYYY-MM-DD).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function toDateInputValue(value) {
  const date = parseDateOnly(value)
  if (!date) return ''

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
